
import retailerMappingThunkActions from "./retailerMappingThunk";

function createExtraReducers() {
  return {
    ...getRetailerMappingHistory(),
  };

  function getRetailerMappingHistory() {
    const { pending, fulfilled, rejected } =
    retailerMappingThunkActions.getRetailerMappingHistory;
    return {
      [pending]: (state) => {
        state.retailerMappingHistory.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.retailerMappingHistory.isLoading = false;
        const newData = action.payload || { content: [], totalPages: 0, totalElements: 0, number: 0 };
        if (newData.number === 0) {
          state.retailerMappingHistory.data = newData;
        } else {
          // For subsequent pages, append the content to existing data
          state.retailerMappingHistory.data = {
            ...newData,
            content: [...state.retailerMappingHistory.data.content, ...newData.content]
          };
        }
      },
      [rejected]: (state, action) => {
        state.retailerMappingHistory = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
        };
      },
    };
  }
}

const retailerExtraReducers = createExtraReducers();
export default retailerExtraReducers;
